"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var dom_1 = require("../utils/dom");
var misc_1 = require("../utils/misc");
exports.allMoveStart$ = new rxjs_1.Subject();
exports.allMoveEnd$ = new rxjs_1.Subject();
exports.allMoveUpdate$ = new rxjs_1.Subject();
exports.createAllMoveObservable = function (_a) {
    var element = _a.element, group = _a.group, onComplete = _a.onComplete, _b = _a.shouldConvertToPercent, shouldConvertToPercent = _b === void 0 ? true : _b;
    return exports.allMoveStart$.pipe(operators_1.switchMap(function () {
        var move$ = exports.allMoveUpdate$.pipe(operators_1.takeUntil(exports.allMoveEnd$), operators_1.filter(isMemberOfGroup(group)), operators_1.pluck('offset'), translateMovementToPosition(element, shouldConvertToPercent));
        move$.subscribe({
            complete: function () { return onComplete && onComplete(); },
        });
        return move$;
    }));
};
/**
 * Do the payload group and observable group match?
 */
var isMemberOfGroup = function (group) { return function (payload) {
    return payload.group === group;
}; };
var translateMovementToPosition = function (element, shouldConvertToPercent) { return function (observable$) {
    return observable$.pipe(operators_1.map(addOffsets(dom_1.offsetOfElement(element))), operators_1.distinctUntilChanged(), operators_1.map(misc_1.convertOffsetToPercentOrPixels(shouldConvertToPercent, element.parentElement)));
}; };
/**
 * Add the change in mouse position to an origin point.
 */
var addOffsets = function (origin) { return function (change) { return ({
    left: origin.left + change.left,
    top: origin.top + change.top,
}); }; };
//# sourceMappingURL=allMove.js.map